/**完成订单 评价订单**/
<template>
  <div class="serviceAgreement">
    <div class="content"
         v-html="infoData"></div>
  </div>
</template>

<script>
  export default {
    name: 'serviceAgreement',
    computed: {},
    data () {
      return {
        infoData: ''
      }
    },
    methods: {
      ArticlebyaliasFn () {
        let that = this
        let params = {
          'alias': 'CustomerServiceAgreement',
          'app_key': window.configure.appKey,
          fn (data) {
            if (data && data.code === 1) {
              that.infoData = data.article.contents
            }
          }
        }
        that.$store.dispatch('Articlebyalias', params)
      }
    },
    watch: {},
    mounted: function () {
      this.ArticlebyaliasFn()
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .serviceAgreement{
    margin-right:15px;
    margin-left:15px;
    margin-top:15px;
    word-wrap:break-word;
    overflow: hidden;
    .ql-align-center{
      text-align: center;
      img{
        width: auto;
        height:auto;
      }
    }
    h2{
      font-weight: bold;
    }
    strong{
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// serviceAgreement.vue?4cef7936